import * as FileSystem from 'expo-file-system';

import { ensureDirectoryExists } from './ensure-directory-exists';
import { getAudioTypeFromDataURL } from './get-audio-type-from-data-url';

export async function saveAudioToLocalCache(
  audioUrl: string,
  soundName: string,
  path: string
): Promise<string> {
  const audioFileType = getAudioTypeFromDataURL(audioUrl);

  const audioDir = FileSystem.cacheDirectory + path;
  await ensureDirectoryExists(audioDir);

  const newAudioUrl = audioDir + `/${soundName}.${audioFileType}`;

  const base64AudioData = audioUrl.replace(
    `data:audio/${audioFileType};base64,`,
    ''
  );
  await FileSystem.writeAsStringAsync(newAudioUrl, base64AudioData, {
    encoding: FileSystem.EncodingType.Base64,
  });

  return newAudioUrl;
}
